module.exports = __webpack_public_path__ + "img/banner3.30720aa7.png";